import { useTranslation } from 'react-i18next';
import { HiOutlineExclamationCircle } from 'react-icons/hi';

import './styles.scss';

export function PaymentMethodNotSupported() {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });

  return (
    <div className="payment-method-not-supported">
      <HiOutlineExclamationCircle color="#DC2626" size={24} />
      <span className="payment-method-not-supported__message">
        {t('paymentMethodNotSupported')}
      </span>
    </div>
  );
}
